import styled from 'styled-components';

import { Typography } from 'src/typography';

/**
 * Shared "heading + sub-copy" presentation primitive: a single paragraph of
 * body text rendered directly beneath a page/section H1, sized and styled
 * to match `Typography.Body size='large'`.
 *
 * Originally the collection description styling (see
 * `src/dispensary/collections/collections-header.tsx`), and reused as-is
 * (same `--dcm-collections-description-color` token, same `margin-top: 8px`
 * spacing) for the category page sub-header (ECOMM-13289) so the two
 * "heading + sub-copy" patterns render identically by default and so any
 * existing customer `--dcm-collections-description-color` override
 * continues to apply to both surfaces without a parallel token.
 *
 * Do not introduce a category-specific `--dcm-category-subheader-*` color
 * token here -- see ECOMM-13289 acceptance criteria.
 */
export const HeadingDescription = styled(Typography.Body)`
  color: var(--dcm-collections-description-color);
  margin-top: 8px;
`;
